export default "__VITE_ASSET__DrPy$YXF__";